import React from 'react'

export default function Case (props) {
  return (
    <svg
      viewBox='0 0 200 200' width={props.width || 17} height={props.height || 17}>
      <path fill={props.color || '#00D8A0'} d='M75,81.2V75c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v6.3h6.3c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3h-6.3v6.3
      c0,3.5-2.8,6.3-6.3,6.3S75,103.5,75,100v-6.3h-6.3c-3.5,0-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3H75z' />
      <path fill={props.color || '#444444'} d='M68.8,43.7H50c-3.5,0-6.3,2.8-6.3,6.3v112.5c0,3.5,2.8,6.3,6.3,6.3h100c3.5,0,6.3-2.8,6.3-6.3V50
      c0-3.5-2.8-6.3-6.3-6.3s-6.3-2.8-6.3-6.3s2.8-6.3,6.3-6.3c10.4,0,18.8,8.4,18.8,18.8v112.5c0,10.4-8.4,18.8-18.8,18.8H50
      c-10.4,0-18.8-8.4-18.8-18.8V50c0-10.4,8.4-18.8,18.8-18.8h18.8c0-6.9,5.6-12.5,12.5-12.5h37.5c6.9,0,12.5,5.6,12.5,12.5v12.5
      c0,6.9-5.6,12.5-12.5,12.5H81.3C74.3,56.2,68.8,50.7,68.8,43.7z' />
      <rect x='81.3' y='31.2' width='37.5' height='12.5' fill={'#FFFFFF'} />
      <path fill={props.color || '#444444'} d='M68.8,118.7h37.5c3.5,0,6.3,2.8,6.3,6.3c0,3.5-2.8,6.3-6.3,6.3H68.8c-3.5,0-6.3-2.8-6.3-6.3
      C62.5,121.5,65.3,118.7,68.8,118.7z' />
      <path fill={props.color || '#444444'} d='M68.8,143.7h62.5c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3H68.8c-3.5,0-6.3-2.8-6.3-6.3S65.3,143.7,68.8,143.7z'
      />
    </svg>
  )
}
